function StockMascot() {

}

StockMascot.events = {
    isInit: true,
    init: function(categoryID = ub.data.stockMascotCategoryID, designID = undefined) {
        var that = this;
        if (that.isInit) {
            $(".inksoft-stock-mascot").on("click", ".stock-mascot-categories a", that.onClickStockMascotCategory);
            $(".inksoft-stock-mascot").on("click", ".stock-mascot-list-container .mascot-item a", that.onClickMascotItem);
            $(".inksoft-stock-mascot").on("click", ".stock-mascot-preview-container .edit-stock-logo", that.onClickEditStockMascot);
            $(".inksoft-stock-mascot").on("click", ".add-to-uniform", that.onClickAddToUniform);
            $(".inksoft-stock-mascot").on("click", ".design-switcher a", that.onSwitchDesignTab);
            $(".inksoft-stock-mascot").on("change", "input.search-saved-logo", that.searchSavedLogo);

            $("#richardson-stock-mascot").on("click", ".cancel-add-uniform", that.onClickCancel);
        }

        that.isInit = false;
        
        if (ub.config.isInksoftAvailable === "yes") {
            StockMascot.funcs.changeModalTitle(categoryID);
            $(".inksoft-stock-mascot .stock-mascot-main-content").addClass("uk-hidden")
            $(".inksoft-stock-mascot .stock-mascot-loading-screen").removeClass("uk-hidden");

            $("#richardson-stock-mascot .uk-modal-footer .add-to-uniform").addClass("uk-disabled");
            StockMascot.funcs.loadStockMascot(categoryID, designID);
        } else {
            ub.utilities.notifyMe("Inksoft is currently under maintenance. Please try again later.", "danger");
        }
    },

    searchSavedLogo() {
        var term = $(this).val()
        var designs = _.filter(ub.data.userInksoftDesign, function(design) {
            return design.design_name.toLowerCase().indexOf(term.toLowerCase()) !== -1;
        });

        var renderContainer = ub.utilities.buildTemplateString('#m-inksoft-user-mascots-list', {
            designs: designs,
            hasDesign: _.size(designs) > 0
        });

        $(".inksoft-stock-mascot div.my-design .stock-mascot-list-container").html("");
        $(".inksoft-stock-mascot div.my-design .stock-mascot-list-container").html(renderContainer);

        if (_.size(designs) > 0) {
            $(".inksoft-stock-mascot .my-design .mascot-item a").first().trigger("click");
        } else {
            $(".inksoft-stock-mascot .stock-mascot-preview-container").html("");
        }
    },

    onSwitchDesignTab: function() {
        var type = $(this).data("type");
        $(`.inksoft-stock-mascot .${type} .mascot-item a`).first().trigger("click");

        if (_.size($(`.inksoft-stock-mascot .${type} .mascot-item a`).first()) <= 0) {
            $(".inksoft-stock-mascot .stock-mascot-preview-container").html("");
        }
    },

    onClickStockMascotCategory: function() {
        var categoryID = $(this).data("category-id");
        $(".inksoft-stock-mascot .stock-mascot-loading-screen-content").removeClass("uk-hidden");
        $(".inksoft-stock-mascot .stock-mascot-list-container").addClass("uk-hidden");
        
        StockMascot.funcs.loadArtByCategory(categoryID, function(response) {
            if (response.OK) {
                StockMascot.funcs.prepareStockMascots(response.Data, undefined);
                $(".inksoft-stock-mascot .stock-mascot-loading-screen-content").addClass("uk-hidden");
                $(".inksoft-stock-mascot .stock-mascot-list-container").removeClass("uk-hidden");
            }
        });

        $(".stock-mascot-categories li.uk-active").removeClass("uk-active");
        $(this).parent().addClass("uk-active");
    },

    onClickMascotItem: function() {
        var that = this;
        var image = $(this).data("image");
        var name = $(this).data("name");
        var stockID = $(this).data("stock-mascot-id");

        ub.data.currentStockMascotID = stockID;

        StockMascot.funcs.previewStockMascotPreview(name, image, stockID);
        $(".inksoft-stock-mascot .mascot-item a.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active");
    },

    onClickEditStockMascot: function() {
        var that = this;
        var stockID = $(this).data("stock-mascot-id");
        var application = ub.data.currentApplication;
        var element = document.querySelector("#inksoftEditor .inksoft-design-editor");
        $("#inksoftEditor .inksoft-design-editor").html("")

        InteropIsPanel.loadDesigner(stockID, application.code, element, function() {
            ub.data.isMessageIsCalled = true;
            UIkit.modal("#richardson-stock-mascot").hide();
            UIkit.modal("#inksoftEditor").show();
        });
    },

    onClickAddToUniform: function() {
        var that = this;
        var stockID = ub.data.currentStockMascotID;

        if (typeof stockID !== "undefined") {
            var _settingsObject = ub.data.currentApplication;
            var _matchingID = undefined;
            ub.data.isMessageIsCalled = true;
            is.isMessage(stockID, _settingsObject.code, true);
            // Check if has Match Application
            _matchingID = ub.data.matchingIDs.getMatchingID(_settingsObject.code);
            if (typeof _matchingID !== "undefined") {
                var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: _matchingID.toString()});
                is.isMessage(stockID, _settingsObject.code, true);
            }
        } else {
            ub.utilities.warn("Missing design id")
        }

        UIkit.modal("#richardson-stock-mascot").hide();
    },

    onClickCancel: function() {
        if (!ub.data.isChangeStockLogo) {
            var _settingsObject = ub.data.currentApplication;
            StockMascot.funcs.onRemoveApplication(_settingsObject);
        }

        ub.data.isChangeStockLogo = false;
        UIkit.modal("#richardson-stock-mascot").hide();
    }
}

StockMascot.funcs = {
    loadStockMascot: function(categoryID = ub.data.stockMascotCategoryID, designID = undefined) {
        var stockMascotCategoryID = categoryID;
        var that = this;

        that.loadRichardsonCategories(function(response) {
            if (response.StatusCode) {
                var richardsonStockMascots = _.find(response.Data, {ID: stockMascotCategoryID});
                if (typeof richardsonStockMascots !== "undefined") {
                    ub.data.stockMascot = richardsonStockMascots;
                    that.prepareStockMascotCategories(ub.data.stockMascot, stockMascotCategoryID);
                    
                    ub.funcs.updateEmbellishmentList(function() {
                        StockMascot.funcs.loadArtByCategory(richardsonStockMascots.ID, function(response) {
                            if (response.OK) {
                                StockMascot.funcs.prepareStockMascots(response.Data, designID);
                                $(".inksoft-stock-mascot .stock-mascot-main-content").removeClass("uk-hidden")
                                $(".inksoft-stock-mascot .stock-mascot-loading-screen").addClass("uk-hidden");
                                $("#richardson-stock-mascot .uk-modal-footer .add-to-uniform").removeClass("uk-disabled");
                            } else {
                                var message = 'Something went wrong. Unable to load inksoft logo.';
                                ub.funcs.showNotification(message, "danger", 5000);
                                UIkit.modal("#richardson-stock-mascot").hide();
                            }
                        });
                    });
                }
            }
        })
        
        UIkit.modal("#richardson-stock-mascot").show();
    },

    prepareStockMascotCategories: function(categories, parentID) {
        if (_.size(categories.Children) === 0) {
            $(".inksoft-stock-mascot .stock-mascot-categories").parent().parent().addClass("uk-hidden");
        } else {
            var renderContainer = ub.utilities.buildTemplateString('#m-inksoft-stock-mascot-categories-list', {
                categories: categories.Children,
                parentID
            });

            $(".inksoft-stock-mascot .stock-mascot-categories").html("");
            $(".inksoft-stock-mascot .stock-mascot-categories").html(renderContainer);
            $(".inksoft-stock-mascot .stock-mascot-categories").parent().parent().removeClass("uk-hidden");
        }
    },

    prepareStockMascots: function(mascots, designID) {
        var data = [];
        var isEdit = true;
        _.each(mascots, function(mascot) {
            if (mascot.DesignID === designID) {
                isEdit = false;
            }
            data.push({
                ImageUrl: ub.data.inkSoftBaseURL + mascot.Canvases[0].PngRelativeUrl,
                thumbnail: ub.data.inkSoftBaseURL + mascot.Canvases[0].ThumbnailRelativeUrl,
                Name: mascot.Name,
                ID: mascot.DesignID
            });
        })

        var renderContainer = ub.utilities.buildTemplateString('#m-inksoft-stock-mascots-list', {
            mascots: data
        });

        $(".inksoft-stock-mascot div.stock-mascot .stock-mascot-list-container").html("");
        $(".inksoft-stock-mascot div.stock-mascot .stock-mascot-list-container").html(renderContainer);
        
        if (!ub.user) {
            $(`.design-switcher a[data-type="my-design"]`).parent().addClass('uk-hidden');
        }

        let type = $(`.design-switcher div.uk-active a`).data("type");

        if (type === "stock-mascot") {
            $(".inksoft-stock-mascot .stock-mascot .mascot-item a").first().trigger("click");
        } else {
            $(".inksoft-stock-mascot .my-design .mascot-item a").first().trigger("click");
        }

        if (!_.isUndefined(designID) || isEdit) {
            $(".inksoft-stock-mascot .stock-mascot .mascot-item a[data-stock-mascot-id='"+ designID +"']").click();
        }
    },

    previewStockMascotPreview: function(name, image, stock_id, element = false) {
        var renderContainer = ub.utilities.buildTemplateString('#m-inksoft-stock-mascot-preview', {
            name: name,
            image: image,
            ID: stock_id
        });

        if (element) {
            element.html("");
            element.html(renderContainer);
        } else {
            $(".inksoft-stock-mascot .stock-mascot-preview-container").html("");
            $(".inksoft-stock-mascot .stock-mascot-preview-container").html(renderContainer);
        }
    },

    loadRichardsonCategories: function(cb) {
        var url = 'https://stores.inksoft.com/richardson_customizer/Api2/GetDesignCategories?Format=JSON';
        ub.utilities.getJSON(url, function(response) {
            cb(response);
        }, function(error) {
            var message = 'Something went wrong, please try again';
            var _settingsObject = ub.data.currentApplication;
            ub.funcs.showNotification(message, "danger", 5000);

            UIkit.modal("#richardson-stock-mascot").hide();
            ub.utilities.info("ERROR while loading Inksoft Stock Mascot");
            ub.utilities.info(error)

            if (typeof _settingsObject !== "undefined") {
                StockMascot.funcs.onRemoveApplication(_settingsObject);
            }
        });
    },

    loadArtByCategory: function(id, cb) {
        var url = 'https://stores.inksoft.com/richardson_customizer/Api2/GetDesignSummaries?DesignCategoryId='+ id +'&Format=JSON';
        ub.utilities.getJSON(url, function(response) {
            cb(response);
        }, function(error) {
            var message = 'Something went wrong, please try again';
            var _settingsObject = ub.data.currentApplication;
            
            if (typeof _settingsObject !== "undefined") {
                StockMascot.funcs.onRemoveApplication(_settingsObject);
            }

            ub.funcs.showNotification(message, "danger", 5000);
            UIkit.modal("#richardson-stock-mascot").hide();
        });
    },

    changeModalTitle: function(id) {
        $("#richardson-stock-mascot .richardson-stock-mascot-header").html("");

        if (ub.data.customTextCategoryID === id) {
            $("#richardson-stock-mascot .richardson-stock-mascot-header").html("Richardson Custom Text");
        } else {
            $("#richardson-stock-mascot .richardson-stock-mascot-header").html("Richardson Stock Logos");
        }
    },

    onRemoveApplication: function(_settingsObject) {
        var _perspective = ub.funcs.getPrimaryView(_settingsObject.application);
        if (_settingsObject.logo_type === "custom_text") {
            TeamNamePanel.funcs.loadAddTeamName();
        } else {
            ub.funcs.afterRemoveStockLogo(_settingsObject);
        }
        // Delete Application
        ub.funcs.deleteLocation(_settingsObject.code);
        // Hide and show of application if it is socks
        if (ub.funcs.isSocks()) {
            MascotPanel.events.afterRemoveStockLogoSocks(_perspective)
        }
    }
}